import { createFileRoute } from '@tanstack/react-router';
import { KpiSummaryTable } from '@/modules/kpi/kpi-summary';

export const Route = createFileRoute('/(dashboard)/_dashboard/performance-review/$id/summary')({
  component: KpiSummaryTable,
});
